const { createAction } = require('../helpers')
const {
  POST_PATIENTS_REVIEW,
  POST_PATIENTS_REVIEW_SUCCESS,
  POST_PATIENTS_REVIEW_ERROR,
  POST_PATIENTS_REVIEW_RESET,
} = require('./constants')

const postPatientReview = data => createAction(POST_PATIENTS_REVIEW, { data })
const postPatientReviewSuccess = data => createAction(POST_PATIENTS_REVIEW_SUCCESS, { data })
const postPatientReviewError = error => createAction(POST_PATIENTS_REVIEW_ERROR, { error })
const postPatientReviewReset = () => createAction(POST_PATIENTS_REVIEW_RESET)

module.exports = {
  postPatientReview,
  postPatientReviewSuccess,
  postPatientReviewError,
  postPatientReviewReset,
}
